import React from 'react';
import styled from 'styled-components';
import useDecodeHtml from '../../hooks/useDecodeHtml';
import { Link } from 'react-router-dom';
import { getPrimaryCategoryName, getPrimaryCategoryUrl } from '../../utils/getPrimaryCategory';

// Styled Components per la griglia
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* Adatta alla larghezza */
  gap: 1.4em;
  margin-top: 2em;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr)); /* Una colonna su mobile */
    margin-top: 1.4em;
  }
`;

const MainItem = styled.div`
  display: flex;
  gap: 1em;

  /* Modalità mobile */
  @media (max-width: 768px) {
    padding-bottom: 1em;
    border-bottom: 1px solid #CC0000;
    gap:0;
    flex-direction: column; /* Disposizione verticale */
    align-items: center; /* Allinea al centro */
  }
`;

const SecondaryItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ResponsiveImageContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* Aspect ratio 16:9, puoi cambiare secondo necessità */
  overflow: hidden;
  border-radius: 5px;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; /* Assicura che l'immagine sia ritagliata per coprire l'intero spazio */

    @media (hover: hover) {
    &:hover {
    transform: scale(1.05);
    cursor: pointer;
}
  }
  }`;

export const SecondaryCard = styled.div`
  @media (max-width: 768px) {
    padding-bottom: 1em;
    border-bottom: 1px solid #CC0000;
    gap:0;
    flex-direction: column; /* Disposizione verticale */
    align-items: center; /* Allinea al centro */
  }
}
`;

export const MainContainer = styled.div`
    margin-bottom: 2em;
    margin-top: 2em;

  @media (max-width: 768px) {
    margin-bottom: 1.4em;
    margin-top: 0em;
  }
}
`;

export const ResponsiveImage = styled.img`
  width:100%;
  border-radius: 5px;

  @media (hover: hover) { 
  &:hover {
    transform: scale(1.03);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
}
`;

const LatestPost = ({ articles }) => {
    const decodeHtml = useDecodeHtml();


    return (
        <MainContainer>
            <MainItem>
                <div style={{ flex: 1.5 }}>
                    <Link to={`/${articles?.[0]?.slug}`} style={{ textDecoration: 'none' }}>
                        <ResponsiveImage
                            src={articles?.[0]?.image}
                            alt={decodeHtml(articles?.[0]?.title)}
                        />
                    </Link>
                </div>
                <SecondaryItem style={{ flex: 1.2 }}>
                    <Link to={getPrimaryCategoryUrl(articles?.[0]?.categories)} style={{ textDecoration: 'none' }}>
                        <h1 style={{ margin: '10px 0', color: '#CC0000' }}>
                            {decodeHtml(getPrimaryCategoryName(articles?.[0]?.categories))}
                        </h1>
                    </Link>
                    <Link to={`/${articles?.[0]?.slug}`} style={{ textDecoration: 'none' }}>
                        <h1 style={{ margin: 0 }}>{decodeHtml(articles?.[0]?.title)}</h1>
                        <p style={{ margin: '10px 0' }}>{articles?.[0]?.excerpt}</p>
                    </Link>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Link
                            to={`/team/${articles?.[0]?.author.name.replace(/\s+/g, '-').toLowerCase()}`}
                            style={{ textDecoration: 'none' }}
                        >
                            <p className='paragraph-author'>{`Di ${articles?.[0]?.author.name}`}</p>
                        </Link>
                    </div>
                </SecondaryItem>
            </MainItem>

            <GridContainer>
                {articles?.slice(1, 4).map((article, index) => (
                    <SecondaryCard key={index}>
                        <Link to={`/${article?.slug}`} style={{ textDecoration: 'none' }}>
                            <ResponsiveImageContainer>
                                <img
                                    src={article?.image}
                                    alt={decodeHtml(article?.title)}
                                />
                            </ResponsiveImageContainer>
                        </Link>
                        <Link to={getPrimaryCategoryUrl(article?.categories)} style={{ textDecoration: 'none' }}>
                            <h1 style={{ margin: '10px 0', color: '#CC0000' }}>
                                {decodeHtml(getPrimaryCategoryName(article?.categories))}
                            </h1>
                        </Link>
                        <Link to={`/${article?.slug}`} style={{ textDecoration: 'none' }}>
                            <h1 style={{ marginTop: 0 }}>{decodeHtml(article?.title)}</h1>
                            <p style={{ margin: '10px 0' }}>{article?.excerpt}</p>
                        </Link>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Link
                                to={`/team/${article?.author?.name.replace(/\s+/g, '-').toLowerCase()}`}
                                style={{ textDecoration: 'none' }}>
                                <p className='paragraph-author'>{`Di ${article?.author?.name}`}</p>
                            </Link>
                        </div>
                    </SecondaryCard>
                ))}
            </GridContainer>
        </MainContainer>
    );
};

export default LatestPost;
